import React from 'react';
import parse from 'html-react-parser';
import styles from './tutorialViewer.module.css';

const TutorialViewer = ({ htmlContent }) => {
    const getParsedHtml = (content) => {
        if (!content) return null;
        try {
            return parse(content);
        } catch (error) {
            console.error("Error al procesar el HTML del tutorial:", error);
            return <div style={{ color: 'red' }}>Error visualizando el contenido.</div>;
        }
    };

    return (
        <div className={styles.contentModal}>
            {getParsedHtml(htmlContent)}
        </div>
    );
};

export default TutorialViewer;